import { Shield, Award, Users, TrendingUp, Lock, CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const TrustSignals = () => {
  const trustMetrics = [
    {
      icon: Shield,
      value: "Enterprise",
      label: "Security Standards",
      description: "Built with enterprise-grade security protocols"
    },
    {
      icon: Award,
      value: "AI-Powered",
      label: "Strategic Intelligence",
      description: "Advanced AI for strategic planning"
    },
    {
      icon: TrendingUp,
      value: "Efficiency",
      label: "Process Optimization",
      description: "Streamlined strategic workflows"
    },
    {
      icon: Users,
      value: "Executive",
      label: "Focused Platform",
      description: "Purpose-built for C-suite leaders"
    }
  ];

  const certifications = [
    { name: "Data Encryption", status: "End-to-End" },
    { name: "Secure Architecture", status: "Enterprise-Grade" },
    { name: "Access Controls", status: "Role-Based" },
    { name: "Audit Logging", status: "Comprehensive" }
  ];

  return (
    <section className="py-16 bg-trust-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Main Trust Metrics */}
        <div className="text-center mb-12">
          <h2 className="heading-md text-corporate-primary mb-4">
            Trusted by Strategic Leaders Worldwide
          </h2>
          <p className="body-md text-corporate-secondary max-w-2xl mx-auto">
            Join the executives who have transformed their strategic planning with enterprise-grade tools.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {trustMetrics.map((metric, index) => (
            <Card key={index} className="text-center border-trust-border hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <metric.icon className="h-8 w-8 mx-auto mb-3 text-corporate-blue" />
                <div className="text-2xl font-bold text-corporate-primary mb-1">
                  {metric.value}
                </div>
                <div className="font-medium text-corporate-primary mb-2">
                  {metric.label}
                </div>
                <div className="text-sm text-corporate-secondary">
                  {metric.description}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Security & Compliance */}
        <div className="bg-white rounded-lg border border-trust-border p-8">
          <div className="flex items-center justify-center mb-6">
            <Lock className="h-6 w-6 text-corporate-primary mr-3" />
            <h3 className="text-xl font-semibold text-corporate-primary">
              Enterprise Security & Compliance
            </h3>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {certifications.map((cert, index) => (
              <div key={index} className="flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-corporate-success" />
                <div>
                  <div className="text-sm font-medium text-corporate-primary">
                    {cert.name}
                  </div>
                  <div className="text-xs text-corporate-secondary">
                    {cert.status}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-corporate-secondary">
              Your data is encrypted in transit and at rest. Full audit logs and enterprise controls available.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;